import styled from "styled-components";

export const CookieModalStyled = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  width: 100%;
  background-color: #FFF3E9;
  padding: 1.5rem 3rem;
  z-index: 100;
  border-top: 1px solid #1D1D1D;
  box-shadow: 0 -2px 10px 0 #0000001A;
  font-family: 'TT Travels', Arial, Helvetica, sans-serif;
  font-size: 14pt;
  line-height: normal;
  color: #000;

  p {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    flex: 1;
    min-width: 0;
  }

  @media (max-width: 1024px) {
    font-size: 12pt;
  }

  @media (max-width: 800px) {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
    padding: 1rem;
    font-size: 11pt;
  }

  @media (max-width: 400px) {
    font-size: 10pt;
  }
`